import { avatarColorType } from '@featuring-corp/components/dist/core-avatar/type';
import clsx from 'clsx';
import React, { ComponentPropsWithoutRef } from 'react';

import { avatarClass, imgClass, noneImgClass } from './style.css';
import CoreImg from '@shared/CoreImg';

export interface LargeAvatarProps extends ComponentPropsWithoutRef<'div'> {
	src?: string;
	alt?: string;
	name?: string;
	colorType?: avatarColorType;
	isBorder?: boolean;
	isLoading?: boolean;
}

const LargeAvatar = ({
	src,
	alt = '',
	name = '',
	colorType = 'gray',
	isBorder = false,
	isLoading = false,
	className,
	...props
}: LargeAvatarProps) => {
	return (
		<div className={clsx(avatarClass({ isBorder }), className)} {...props}>
			{isLoading && <CoreImg src={src ?? ''} alt={alt} is_loading />}
			{!isLoading && src && <CoreImg src={src} alt={alt} className={imgClass} />}
			{!isLoading && !src && <div className={noneImgClass({ colorType })}>{name[0]}</div>}
		</div>
	);
};

export default LargeAvatar;
